import { render, staticRenderFns } from "./DiasFestivos.vue?vue&type=template&id=c6389624&scoped=true"
import script from "./DiasFestivos.vue?vue&type=script&lang=js"
export * from "./DiasFestivos.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DiasFestivos.vue?vue&type=style&index=1&id=c6389624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6389624",
  null
  
)

export default component.exports